<template>
  <div class="information">
    <div class="information_top">
      <van-icon
        style="position: absolute; left: 10px"
        size="25"
        name="arrow-left"
        @click="to()"
      />
      <div class="my">基本信息</div>
      <div class="determine" @click="baocun">
        {{ userInfo.scholarBaseInfo.auditStatus === 0 ? "审核中" : "保存" }}
      </div>
    </div>
    <div class="information_bottom">
      <!-- 回显不通过原因 -->
      <van-cell-group
        class="cell_group_box"
        v-if="
          userInfo.scholarBaseInfo && userInfo.scholarBaseInfo.auditStatus === 2
        "
      >
        <van-cell
          class="scholar_text"
          is-link
          :title="userInfo.scholarBaseInfo.cause"
          :to="{
            path: 'noPass',
            query: { cause: userInfo.scholarBaseInfo.cause },
          }"
        />
      </van-cell-group>
      <van-cell-group class="cell_group_box">
        <van-cell class="upload_box" :required="true" title="头像" center>
          <template>
            <van-image
              class="upload_img"
              round
              width="37px"
              height="37px"
              :src="
                userInfos.headPhoto
                  ? $global.imgUrl + userInfos.headPhoto
                  : require('@/assets/img/mobile-img/upload-default.png')
              "
              @click="preview(userInfos.headPhoto)"
            />
            <van-uploader
              :max-size="1 * 1024 * 1024"
              :before-read="beforeRead"
              :after-read="(file) => clzpAfterRead(file, 'periodicalLogo')"
              @oversize="onOversize"
            >
              <van-icon class="upload_icon" name="arrow" />
            </van-uploader>
          </template>
          <!-- <van-uploader
            :max-count="1"
            :max-size="1 * 1024 * 1024"
            :preview-full-image="false"
            :deletable="false"
            v-model="fileList"
            :before-read="beforeRead"
            :after-read="clzpAfterRead"
            :upload-icon="require('@/assets/img/mobile-img/upload-default.png')"
            @oversize="onOversize"
          >
          </van-uploader> -->
          <!-- <img
              class="upload_img"
              v-lazy="$global.imgUrl + userInfos.headPhoto"
              alt=""
            /> -->
        </van-cell>
        <van-cell
          title="姓名"
          :value="userInfos.realname"
          :required="true"
          is-link
          @click="
            toEdit('realname', 'fullname', { realname: 'userInfo.realname' })
          "
        />
        <van-cell
          title="性别"
          :value="userInfos.sex"
          is-link
          @click="openSheet('sex', sexOptions)"
        />
        <van-cell
          title="出生年份"
          :value="userInfos.birthday ? userInfos.birthday.slice(0, 4) : ''"
          is-link
          @click="openSheet('birthday', ageOptions)"
        />
        <van-cell
          title="民族"
          :value="userInfos.nation"
          is-link
          @click="toEdit('nation', 'nation')"
        />
        <van-cell
          title="学历/学位"
          :value="userInfos.education"
          is-link
          @click="openSheet('education', inStudyOptions)"
        />
        <van-cell
          v-show="hasInStudy"
          title="是否在读"
          :value="userInfos.inStudy == 1 ? '是' : '否'"
          is-link
          @click="openSheet('inStudy', inStudyOptions)"
        />
        <van-cell
          title="毕业院校"
          :value="userInfos.school"
          is-link
          @click="toEdit('school', 'school', { school: 'userInfo.school' })"
        />
        <van-action-sheet
          v-model="sheetShow"
          :actions="sheetOptions"
          @select="sheetOnSelect"
        />
        <van-action-sheet v-model="educationShow">
          <van-picker
            ref="eduRef"
            value-key="label"
            :show-toolbar="true"
            :columns="educationOptions"
            @confirm="educationPickerConfirm"
            @cancel="() => (educationShow = false)"
          />
        </van-action-sheet>
      </van-cell-group>
      <van-cell-group class="cell_group_box">
        <van-cell center :required="true" title="职称">
          <van-button
            size="small"
            style="
              border: none;
              color: #4a79f1;
              font-size: 14px;
              list-style: none;
            "
            @click="toAdd('TitleList')"
            >添加</van-button
          >
        </van-cell>
        <van-cell
          is-link
          v-for="(item, index) in TitleList"
          :title="'职称' + Number(index + 1)"
          :key="item.id"
          @click="
            toEdit('titles', 'deletetitle', {
              item: JSON.stringify(item),
              indexs: index,
            })
          "
        >
          <div
            style="
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            "
          >
            <span>{{ item.levelOneName }}</span>
            <span v-if="item.levelTwo">-{{ item.levelTwo }}</span>
          </div>
        </van-cell>
      </van-cell-group>
      <van-cell-group class="cell_group_box">
        <van-cell :required="true" title="学科领域">
          <van-button
            size="small"
            style="
              border: none;
              color: #4a79f1;
              font-size: 14px;
              list-style: none;
            "
            @click="toAdd('SubjectList')"
            >添加</van-button
          >
        </van-cell>
        <van-cell
          v-for="(item, index) in SubjectList"
          :key="item.id"
          :title="'学科领域' + Number(index + 1)"
          is-link
          @click="
            toEdit('subjects', 'deletearea', {
              item: JSON.stringify(item),
              indexs: index,
            })
          "
        >
          <div
            style="
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            "
          >
            <span>{{ item.levelOneName }}</span
            >-<span>{{ item.levelTwoName }}</span>
          </div>
        </van-cell>
      </van-cell-group>
      <van-cell-group class="cell_group_box">
        <van-cell
          :required="true"
          title="研究方向"
          :value="userInfos.researchDirection"
          is-link
          @click="
            toEdit('researchDirection', 'study', {
              researchDirection: userInfo.researchDirection,
            })
          "
          style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis"
        />
      </van-cell-group>
      <van-cell-group class="cell_group_box">
        <van-cell :required="true" title="任职机构">
          <van-button
            size="small"
            style="
              border: none;
              color: #4a79f1;
              font-size: 14px;
              list-style: none;
            "
            @click="toAdd('scholarPresentUnit')"
            >添加</van-button
          >
        </van-cell>
        <van-cell
          :title="'任职机构' + Number(index + 1)"
          v-for="(item, index) in scholarPresentUnit"
          :key="item.id"
          is-link
          @click="
            toEdit('Adeletebe', 'Adeletebe', {
              item: JSON.stringify(item),
              index,
              sessionName: 'scholarUserInfos',
              key: 'scholarPresentUnit',
            })
          "
        >
          <div
            style="
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            "
          >
            <span>{{ item.unitName }}</span>
          </div>
        </van-cell>
      </van-cell-group>
      <van-cell-group class="cell_group_box">
        <van-cell title="原任职机构" center>
          <van-button
            size="small"
            style="
              border: none;
              color: #4a79f1;
              font-size: 14px;
              list-style: none;
            "
            @click="toAdd('OriginalUnitList')"
            >添加</van-button
          >
        </van-cell>
        <van-cell
          v-for="(item, index) in OriginalUnitList"
          :key="item.id"
          :title="'原任职机构' + Number(index + 1)"
          center
          is-link
          @click="
            toEdit('Adeletebe', 'Adeletebe', {
              item: JSON.stringify(item),
              index,
              sessionName: 'scholarUserInfos',
              key: 'scholarOriginalUnit',
            })
          "
        >
          <div
            style="
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            "
          >
            <span>{{ item.unitName }}</span>
          </div>
        </van-cell>
      </van-cell-group>
      <van-cell-group class="cell_group_box">
        <van-cell
          title="个人简介"
          :value="userInfos.profile"
          is-link
          style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap"
          @click="toEdit('profile', 'PersonalProfile')"
        />
      </van-cell-group>
      <div style="margin-top: 13px; padding: 0px 0px 0px 16px">个人履历</div>
      <van-cell-group class="record_box cell_group_box">
        <div class="record_item">
          <van-cell
            :value="newList1.content ? newList1.content : '未设置'"
            is-link
            :to="{
              path: 'education',
              query: { educationId: educationId },
            }"
          >
            <template #title>
              <span>教育背景</span>
              <span :class="['record_tag', recordTag(newList1.auditStatus)]">{{
                newList1.auditStatus | tagType
              }}</span>
            </template>
          </van-cell>
          <div
            class="record_reason"
            v-if="newList1.auditStatus == 2 && newList1.reason"
          >
            {{ newList1.reason }}
          </div>
        </div>
        <div class="record_item">
          <van-cell
            :value="newList2.content ? newList2.content : '未设置'"
            is-link
            :to="{
              path: 'work',
              query: { workId: workId },
            }"
          >
            <template #title>
              <span>工作经历</span>
              <span :class="['record_tag', recordTag(newList2.auditStatus)]">{{
                newList2.auditStatus | tagType
              }}</span>
            </template>
          </van-cell>
          <div
            class="record_reason"
            v-if="newList2.auditStatus == 2 && newList2.reason"
          >
            {{ newList2.reason }}
          </div>
        </div>
        <div class="record_item">
          <van-cell
            :value="newList3.content ? newList3.content : '未设置'"
            is-link
            :to="{
              path: 'experience',
              query: { experienceId: experienceId },
            }"
          >
            <template #title>
              <span>职称经历</span>
              <span :class="['record_tag', recordTag(newList3.auditStatus)]">{{
                newList3.auditStatus | tagType
              }}</span>
            </template>
          </van-cell>
          <div
            class="record_reason"
            v-if="newList3.auditStatus == 2 && newList3.reason"
          >
            {{ newList3.reason }}
          </div>
        </div>
        <div class="record_item">
          <van-cell
            :value="newList4.content ? newList4.content : '未设置'"
            is-link
            :to="{
              path: 'society',
              query: { societyId: societyId },
            }"
          >
            <template #title>
              <span>社会任职</span>
              <span :class="['record_tag', recordTag(newList4.auditStatus)]">{{
                newList4.auditStatus | tagType
              }}</span>
            </template>
          </van-cell>
          <div
            class="record_reason"
            v-if="newList4.auditStatus == 2 && newList4.reason"
          >
            {{ newList4.reason }}
          </div>
        </div>
        <div class="record_item">
          <van-cell
            :value="newList5.content ? newList5.content : '未设置'"
            is-link
            :to="{
              path: 'Awards',
              query: { awardsId: awardsId },
            }"
          >
            <template #title>
              <span>获奖情况</span>
              <span :class="['record_tag', recordTag(newList5.auditStatus)]">{{
                newList5.auditStatus | tagType
              }}</span>
            </template>
          </van-cell>
          <div
            class="record_reason"
            v-if="newList5.auditStatus == 2 && newList5.reason"
          >
            {{ newList5.reason }}
          </div>
        </div>
      </van-cell-group>
    </div>
  </div>
</template>

<script>
import { Toast, ImagePreview } from "vant";
export default {
  name: "information",
  data() {
    return {
      // 学者所有信息
      scholarUserInfo: "",
      fileList: [],
      userInfo: {
        scholarBaseInfo: {
          auditStatus: 1,
        },
      },
      // 基本信息
      userInfos: {},
      // 职称
      TitleList: [],
      // 科学领域
      SubjectList: [],
      // 任职机构
      scholarPresentUnit: [],
      // 原任职机构
      OriginalUnitList: [],
      sheetShow: false,
      sheetKey: "",
      sheetOptions: [],
      // 性别选项
      sexOptions: [{ name: "男" }, { name: "女" }],
      // 年龄选项
      ageOptions: [],
      educationShow: false,
      // 学历选项
      educationOptions: [],
      // 是否在读选项
      inStudyOptions: [
        { name: "是", num: 1 },
        { name: "否", num: 0 },
      ],
      // 教育背景
      educationId: "",
      // 工作经历
      workId: "",
      // 职称经历
      experienceId: "",
      // 社会任职
      societyId: "",
      // 获奖情况
      awardsId: "",
      newList1: {},
      newList2: {},
      newList3: {},
      newList4: {},
      newList5: {}, //获奖情况
      // 不通过原因
      cause: "",
    };
  },
  created() {
    this.$nextTick(() => {
      if (sessionStorage.getItem("scholarUserInfos")) {
        this.userInfo = JSON.parse(sessionStorage.getItem("scholarUserInfos"));
        this.userInfos = this.userInfo.userInfo;
        this.formatList();
      } else {
        this.getUserDetails();
      }
      this.getData(); // 获取个人履历
      this.getPrizeInfo(); // 获取获奖情况
      this.actions1List(); // 获取年龄数据
      this.getEducationOptionsList(); // 获取学历下拉数据
    });
  },
  filters: {
    tagType(num) {
      if (num == 0) return `审核中`;
      if (num == 2) return `未通过`;
    },
  },
  computed: {
    hasInStudy() {
      if (this.userInfos.eduVal) {
        let eduValArr = this.userInfos.eduVal.split(",");
        let secendValue = eduValArr[1];
        return secendValue != "5" && secendValue != "8" && secendValue != "10";
      } else {
        return true;
      }
    },
  },
  methods: {
    // 预览上传的图片
    preview(url) {
      if (url) {
        ImagePreview({
          images: [this.$global.imgUrl + url],
          closeable: true,
        });
      }
    },
    async getEducationOptionsList() {
      const { resultCode, data } = await this.$apis.userServe.getEducation();
      if (resultCode === "200") {
        this.educationOptions = data.map((item) => {
          return {
            label: item.label,
            value: item.value,
            children: item.childrens,
          };
        });
      }
    },
    // 学历选择框选择出发
    educationPickerConfirm(value) {
      let selectValues = this.$refs.eduRef
        .getValues()
        .map((item) => item.value);
      this.userInfos.education = value[1];
      this.userInfos.eduVal = selectValues.join();
      if (
        selectValues[1] === "5" ||
        selectValues[1] === "8" ||
        selectValues[1] === "10"
      ) {
        this.userInfos.inStudy = 0;
      }
      sessionStorage.setItem("scholarUserInfos", JSON.stringify(this.userInfo));
      this.educationShow = false;
    },
    // 打开下拉选项
    openSheet(key, options) {
      if (this.userInfo.scholarBaseInfo.auditStatus === 0) {
        Toast("审核中");
      } else if (key === "education") {
        this.educationShow = true;
      } else if (key === "inStudy" && this.userInfos.education === "") {
        Toast("请先选择学历/学位");
      } else {
        this.sheetShow = true;
        this.sheetKey = key;
        this.sheetOptions = options;
      }
    },
    // 修改跳转二级页面
    toEdit(key, path, query) {
      if (this.userInfo.scholarBaseInfo.auditStatus === 0) {
        Toast("审核中");
      } else {
        this.$router.push({ path, query });
      }
    },
    recordTag(type) {
      if (type == 0) return `is_audit`;
      if (type == 2) return `no_pass`;
    },
    toAdd(key) {
      if (this.userInfo.scholarBaseInfo.auditStatus === 0) {
        Toast("审核中");
      } else {
        if (this[key].length < 10) {
          this[key].push({});
        } else {
          Toast("最多能添加10条");
        }
      }
    },
    formatList() {
      this.fileList = this.userInfos.headPhoto
        ? [{ url: this.$global.imgUrl + this.userInfos.headPhoto }]
        : [];
      // 遍历职称
      if (
        this.userInfo.sysUserTitle &&
        this.userInfo.sysUserTitle.length !== 0
      ) {
        for (let i = 0; i < this.userInfo.sysUserTitle.length; i++) {
          this.TitleList.push(this.userInfo.sysUserTitle[i]);
        }
      }
      // 遍历科学领域
      if (
        this.userInfo.sysUserSubject &&
        this.userInfo.sysUserSubject.length !== 0
      ) {
        for (let i = 0; i < this.userInfo.sysUserSubject.length; i++) {
          this.SubjectList.push(this.userInfo.sysUserSubject[i]);
        }
      }
      // 遍历原任职机构
      if (
        this.userInfo.scholarOriginalUnit &&
        this.userInfo.scholarOriginalUnit.length !== 0
      ) {
        for (let i = 0; i < this.userInfo.scholarOriginalUnit.length; i++) {
          this.OriginalUnitList.push(this.userInfo.scholarOriginalUnit[i]);
        }
      }
      // 遍历任职机构
      if (
        this.userInfo.scholarPresentUnit &&
        this.userInfo.scholarPresentUnit.length !== 0
      ) {
        for (let i = 0; i < this.userInfo.scholarPresentUnit.length; i++) {
          this.scholarPresentUnit.push(this.userInfo.scholarPresentUnit[i]);
        }
      }
    },
    // 年龄数据
    actions1List() {
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      for (let i = 1900; i < currentYear + 1; i++) {
        this.ageOptions.unshift({ name: i });
      }
    },
    verifyRequired(key, message) {
      if (this.userInfos[key] === "") {
        Toast(message);
        return true;
      }
    },
    verifyRequiredList(listKey, key, message) {
      if (this[listKey].length === 0 || this[listKey][0][key] === "" || this[listKey][0][key] === undefined) {
        Toast(message);
        return true;
      }
    },
    // 保存修改信息
    async baocun() {
      if (this.userInfo.scholarBaseInfo.auditStatus === 0) return;
      if (this.verifyRequired("headPhoto", "请上传头像")) return;
      if (this.verifyRequired("realname", "请填写姓名")) return;
      if (this.verifyRequired("researchDirection", "请填写研究方向")) return;
      if (this.verifyRequiredList("TitleList", "levelOne", "请填写职称"))
        return;
      if (this.verifyRequiredList("SubjectList", "levelTwo", "请填写学科领域"))
        return;
      if (
        this.verifyRequiredList(
          "scholarPresentUnit",
          "unitName",
          "请填写任职机构"
        )
      )
        return;
      let baseInfoDto = {
        userInfo: this.userInfos,
        titles: this.TitleList,
        subjects: this.SubjectList,
        scholarPresentUnits: this.scholarPresentUnit,
        originalUnits: this.OriginalUnitList,
      };
      let res = await this.$apis.userServe.setUserInfo(baseInfoDto);
      if (res.data.resultCode === "200") {
        Toast("修改成功");
        sessionStorage.removeItem("scholarUserInfos");
        sessionStorage.removeItem("scholarUserInfo");
        this.$router.push("My");
      } else {
        Toast(res.data.resultDesc);
      }
    },
    // 学者基本信息
    async getUserDetails() {
      let { content } = await this.$apis.userServe.userDetails();
      let obj = content.detail;
      if (obj.scholarBaseInfo.auditStatus === 0) {
        obj.scholarOriginalUnit = obj.scholarBaseInfo.baseInfo.originalUnits;
        obj.scholarPresentUnit =
          obj.scholarBaseInfo.baseInfo.scholarPresentUnits;
        obj.sysUserSubject = obj.scholarBaseInfo.baseInfo.subjects;
        obj.sysUserTitle = obj.scholarBaseInfo.baseInfo.titles;
        obj.userInfo = obj.scholarBaseInfo.baseInfo.userInfo;
      }
      this.userInfo = obj;
      this.userInfos = this.userInfo.userInfo;
      sessionStorage.setItem("scholarUserInfo", JSON.stringify(this.userInfo));
      sessionStorage.setItem("scholarUserInfos", JSON.stringify(this.userInfo));
      this.formatList();
    },
    // 个人履历
    async getData() {
      let { data } = await this.$apis.userServe.getexperience();
      if (data.length > 0) {
        data.forEach((item) => {
          // 教育背景
          if (item.type == 6) {
            this.newList1 = item;
            this.educationId = item.id;
            sessionStorage.setItem(
              "educationcontent",
              JSON.stringify(item.content)
            );
            // 工作经历
          } else if (item.type == 9) {
            this.newList2 = item;
            this.workId = item.id;
            sessionStorage.setItem("workcontent", JSON.stringify(item.content));
            // 职称经历
          } else if (item.type == 7) {
            this.newList3 = item;
            this.experienceId = item.id;
            sessionStorage.setItem(
              "experiencecontent",
              JSON.stringify(item.content)
            );
            // 社会任职
          } else if (item.type == 8) {
            this.newList4 = item;
            this.societyId = item.id;
            sessionStorage.setItem(
              "societycontent",
              JSON.stringify(item.content)
            );
          }
        });
      }
    },
    // 获取获奖情况
    async getPrizeInfo() {
      let res = await this.$apis.userServe.getPrizeInfo();
      if (res.data) {
        this.newList5 = res.data;
        this.awardsId = res.data.id;
        sessionStorage.setItem(
          "awardscontent",
          JSON.stringify(res.data.content)
        );
      }
    },
    to() {
      sessionStorage.removeItem("scholarUserInfos");
      sessionStorage.removeItem("scholarUserInfo");
      this.$router.push("my");
    },
    sheetOnSelect(params) {
      this.sheetShow = false;
      if (this.sheetKey === "birthday") {
        this.userInfo.userInfo[this.sheetKey] = params.name + "-00-00 00:00:00";
      } else if (this.sheetKey === "inStudy") {
        this.userInfo.userInfo[this.sheetKey] = params.num;
      } else {
        this.userInfo.userInfo[this.sheetKey] = params.name;
      }
      sessionStorage.setItem("scholarUserInfos", JSON.stringify(this.userInfo));
    },
    //校验上传图片大小
    onOversize(file) {
      Toast("文件大小不能超过10MB");
    },
    //校验图片的格式
    beforeRead(file) {
      if (!/(jpg|jpeg|png|JPG|PNG)/i.test(file.type)) {
        Toast("仅支持JPG、JPEG、PNG格式");
        return false;
      }
      return true;
    },
    //照片上传事件方法
    async clzpAfterRead(file) {
      // 创建一个空对象实例
      let formData = new FormData();
      console.log(file);
      // 调用append()方法添加数据
      formData.append("file", file.file);
      const res = await this.$apis.myServe.uploadFileMannual(formData);
      // this.$set(this.userInfo.userInfo, "headPhoto", res.data);
      this.userInfo.userInfo.headPhoto = res.data;
      sessionStorage.setItem("scholarUserInfos", JSON.stringify(this.userInfo));
    },
  },
};
</script>

<style lang="scss" scoped>
// 全局通用样式
.information {
  width: 100vw;
  min-height: 100vh;
  overflow: hidden;
  background: #f5f5f5;

  .information_top {
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    line-height: 44px;

    .my {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      background: #fff;
      text-align: center;
    }

    .determine {
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      position: absolute;
      right: 15px;
    }
  }

  .information_bottom {
    width: 94%;
    height: 100%;
    margin: 0 auto;
    padding-bottom: 20px;

    .cell_group_box {
      margin-top: 13px;
      border-radius: 8px;
      overflow: hidden;
    }

    .info-photo-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 14px auto;
      padding: 0 8px;
      width: 100%;
      height: 48px;
      background: #fff;

      .info-photo-requird {
        width: 7px;
        height: 7px;
      }

      .info-photo-upload {
        width: 35px;
        height: 35px;
        border-radius: 50%;

        .info-photo-img {
          width: 35px;
          height: 35px;
          border-radius: 50%;
        }
      }
    }

    .scholar_text {
      width: 100%;
      height: 48px;
      line-height: 28px;
      background: #fff;
      &::v-deep .van-cell__title {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .upload_box {
      .upload_img {
        margin-right: 10px;
        vertical-align: middle;
      }

      .upload_img_card {
        border-radius: 5px;
        overflow: hidden;
      }

      .upload_icon {
        height: 24px;
        font-size: 16px;
        line-height: 24px;
        color: #969799;
        vertical-align: middle;
      }
      // width: 35px;
      // height: 35px;
      // &::v-deep .van-cell__value {
      //   height: 37px;
      //   .van-uploader__wrapper {
      //     //   // width: 100%;
      //     //   // height: 100%;
      //     .van-uploader__preview,
      //     .van-uploader__upload {
      //       margin: 0;
      //       width: 37px;
      //       height: 37px;
      //       border-radius: 50%;
      //       .van-image {
      //         width: 37px;
      //         height: 37px;
      //         border-radius: 50%;
      //       }
      //       .van-uploader__upload-icon {
      //         img {
      //           width: 37px;
      //           height: 37px;
      //         }
      //       }
      //     }
      //   }
      // }
      // .upload_img {
      //   width: 35px;
      //   height: 35px;
      //   border-radius: 50%;
      // }
    }

    .record_box {
      padding: 0 16px;
      .record_item {
        padding-bottom: 17px;
        border-bottom: 1px solid #eeeeee;
        &::v-deep .van-cell {
          padding: 10px 0 0;
          .van-cell__value {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          &::after {
            content: none;
          }
          .record_tag {
            display: inline-block;
            margin-left: 5px;
            padding: 0 5px;
            font-size: 11px;
            border-radius: 2px;
          }
          .is_audit {
            background-color: #fea7361a;
            color: #fea736;
          }
          .no_pass {
            background-color: #ff3d3d1a;
            color: #ff3d3d;
          }
        }
        .record_reason {
          margin-top: 12px;
          padding: 0 10px;
          width: 100%;
          height: 32px;
          line-height: 32px;
          border-radius: 5px;
          background-color: #f5f5f5;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 13px;
          color: #ff132f;
        }
      }
    }
  }
}
</style>
